import React from "react";
import { CountryDropdown } from "react-country-region-selector";
import { useProductData } from "@/zustand/productStore";

const CountryField = ({ label, value, error, name, handleChange }) => {
  const { country_code } = useProductData();
  const isEnhancedContrast = window.enhancedContrast;

  if (country_code) {
    return (
      <div className="input-container" style={{ width: "100%" }}>
        <div
          className={`input ${error && "input--error"} ${isEnhancedContrast && "enhancedContrast"} ${isEnhancedContrast && "enhancedContrast" && error && "enhancedContrast__error"}`}
        >
          {label && (
            <span
              className={`styledLabel styledLabel--active ${isEnhancedContrast && "enhancedContrast" && "styledLabel__enhancedContrast"}`}
            >
              {label}
            </span>
          )}
          <div className="input--customSelect">
            <CountryDropdown
              id="country"
              valueType="short"
              labelType="full"
              value={value?.toUpperCase() || country_code}
              classes={`input--select overflowed-select ${isEnhancedContrast && "enhancedContrast"}`}
              autoComplete="country-name"
              name={name}
              onChange={(value) => {
                handleChange(value);
              }}
            />
          </div>
        </div>
        {error && (
          <div className="formError" style={{ marginTop: "4px" }}>
            {error}
          </div>
        )}
      </div>
    );
  }
};

export default CountryField;
